<!-- MODAL HEADER -->
<div class="modal-header no-print">
  <h5 class="modal-title" style="color: #36414a; font-weight: 600">
    PRÉ-VISUALIZAÇÃO
  </h5>
  <button
    type="button"
    class="btn-close"
    style="color: #36414a; background: none; border: none"
    aria-label="Fechar"
    (click)="fechar()"
  >
    X
  </button>
</div>

<!-- CONTEÚDO QUE SERÁ IMPRESSO -->
<div class="modal-impressao" style="max-height: 500px; overflow-y: auto">
  <div id="printOnly">
    <div
      class="card-impressao"
      *ngFor="let obra of dadosApi?.works"
      style="page-break-after: always"
    >
      <div class="ficha-impressao" style="margin: auto; padding: 1.5rem">
        <!-- HEADER -->
        <div
          class="header"
          style="
            display: flex;
            justify-content: space-between;
            gap: 2rem;
            margin-bottom: 1rem;
            border-bottom: 1px solid #c1c1c1;
          "
        >
          <div class="header-title">
            <h2
              style="
                margin: 0 0 0.5rem 0;
                font-size: 0.8rem;
                color: #36414a;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 1px;
              "
            >
              FICHA DA OBRA
            </h2>
            <h1
              style="
                margin-bottom: 8px;
                font-size: 1.2rem;
                color: #da6c00;
                font-weight: 700;
              "
            >
              {{ obra?.workDetails.name }}
            </h1>
            <p style="font-size: 0.85rem; color: #36414a">
              <strong>ID</strong> {{ obra?.workDetails.id }}
            </p>
          </div>
          <div style="text-align: right; font-size: 0.9rem; flex-shrink: 0">
            <div style="margin-bottom: 8px">
              <span
                style="
                  color: #36414a;
                  padding: 0.4rem 1rem;
                  border-radius: 16px;
                  font-weight: bold;
                  font-size: 0.85rem;
                "
              >
                {{ obra?.workDetails.phase }}
              </span>
            </div>
            <p style="color: #36414a; font-size: 0.8rem; margin-bottom: 8px">
              <strong>Término:</strong>
              {{ obra?.workDetails.endingDate | date : "yyyy - MMMM" }}
            </p>
            <p style="color: #36414a; font-size: 0.8rem; margin-bottom: 8px">
              <strong>Atualizada:</strong>
              {{ obra?.workDetails.updateDate | date : "yyyy - MMMM" }}
            </p>
          </div>
        </div>

        <!-- LOCALIZAÇÃO E STATUS -->
        <div
          class="row loca-status"
          style="
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 1rem;
       
            border-bottom: 1px solid #c1c1c1;
          "
        >
          <div style="flex: 1; text-align: left; padding-right: 1rem">
            <h6
              style="
                font-size: 14px;
                color: #36414a;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 1px;
              "
            >
              LOCALIZAÇÃO
            </h6>
            <div
              style="font-size: 14px; color: #36414a"
              [innerHTML]="obra?.workDetails.locationDescription"
            ></div>
          </div>
          <div style="flex: 1; text-align: left; padding-left: 1rem">
            <h6
              style="
                font-size: 14px;
                color: #36414a;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 1px;
              "
              *ngIf="
                obra?.workDetails.clientSpecific.potentialScore ||
                obra?.workDetails.clientSpecific.responsible
              "
            >
              STATUS
            </h6>
            <p
              *ngIf="obra?.workDetails.clientSpecific.responsible"
              style="margin: 0.2rem 0; font-size: 0.9rem; color: #36414a"
            >
              Responsável:
              {{ obra?.workDetails.clientSpecific.responsible }}
            </p>
            <p
              *ngIf="obra?.workDetails.clientSpecific.potentialScore"
              style="margin: 0.2rem 0; font-size: 0.9rem; color: #36414a"
            >
              Potencial:
              <span style="color: #da6c00">
                {{ obra?.workDetails.clientSpecific.potentialScore }}
              </span>
            </p>
          </div>
        </div>

        <!-- CONSTRUTORA E CONTATOS -->
        <ng-container *ngIf="obra?.contacts?.companies?.length > 0">
          <h6
            style="
              font-size: 14px;
              color: #da6c00;
              font-weight: bold;
              text-transform: uppercase;
              letter-spacing: 1px;
            "
          >
            CONSTRUTORA
          </h6>

          <div *ngFor="let empresa of obra?.contacts.companies">
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 2rem;
                margin-bottom: 0.5rem;
              "
            >
              <!-- Coluna Empresa -->
              <div style="flex: 1; min-width: 350px; max-width: 150px">
                <strong
                  style="
                    font-size: 0.8rem;
                    color: #36414a;
                    font-weight: bold;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                  "
                  >{{ empresa.companyTradeName }}</strong
                >
                <div style="font-size: 0.9rem; color: #36414a">
                  CNPJ: {{ empresa.companyCNPJ }}
                </div>
              </div>

              <!-- Coluna Telefones -->
              <div style="flex: 1; min-width: 350px; max-width: 150px">
                <div style="display: flex; flex-direction: column; gap: 0.2rem">
                  <span
                    *ngIf="empresa.companyPhone1"
                    style="font-size: 0.9rem; color: #36414a"
                  >
                    {{ empresa.companyPhone1 }}
                  </span>
                  <span
                    *ngIf="empresa.companyPhone2"
                    style="font-size: 0.9rem; color: #36414a"
                  >
                    {{ empresa.companyPhone2 }}
                  </span>
                </div>
              </div>
            </div>

            <!-- CONTATOS -->
            <h6
              style="
                font-size: 14px;
                color: #da6c00;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 1px;
                margin-top: 1rem;
              "
            >
              CONTATOS
            </h6>
            <div
              *ngIf="empresa.contacts?.length === 0"
              style="font-size: 0.9rem; color: #36414a"
            >
              Nenhum contato cadastrado.
            </div>
            <div
              *ngFor="let contato of empresa.contacts"
              style="
                margin-bottom: 1rem;
                border-bottom: 1px solid #c1c1c1;
                padding-bottom: 0.5rem;
              "
            >
              <p style="margin: 0.2rem 0; font-size: 0.9rem; color: #36414a">
                <strong>{{ contato.contactName }}</strong>
              </p>
              <p style="margin: 0.2rem 0; font-size: 0.9rem; color: #36414a">
                {{ contato.contactRole }}
              </p>
              <p style="margin: 0.2rem 0; font-size: 0.9rem; color: #36414a">
                {{ contato.contactEmail }}
              </p>
              <div
                style="
                  display: flex;
                  gap: 1.5rem;
                  margin: 0.2rem 0;
                  font-size: 0.9rem;
                  color: #36414a;
                "
              >
                <span *ngIf="contato.contactPhone1">
                  Telefone: {{ contato.contactPhone1 }}
                </span>
                <span *ngIf="contato.contactPhone2">
                  Telefone: {{ contato.contactPhone2 }}
                </span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- DETALHES DA OBRA -->
        <div class="section" *ngIf="obra?.workDetails.categories">
          <h3
            style="
              font-size: 14px;
              color: #da6c00;
              font-weight: bold;
              margin-bottom: 1.25rem;
              text-transform: uppercase;
              letter-spacing: 1px;
            "
          >
            NÚMEROS DA OBRA
          </h3>
          <div
            *ngFor="let categoria of obra?.workDetails.categories"
            style="margin-bottom: 1rem"
          >
            <h5
              style="
                font-size: 0.8rem;
                color: #36414a;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 1px;
              "
            >
              {{ categoria.name }}
            </h5>
            <ng-container *ngIf="categoria.name === 'Cronograma'">
              <ul
                style="
                  margin: 0.2rem 0;
                  font-size: 0.9rem;
                  color: #36414a;
                  padding-left: 1.2rem;
                "
              >
                <li *ngFor="let item of categoria.values">{{ item }}</li>
              </ul>
            </ng-container>
            <ng-container *ngIf="categoria.name === 'Mais Detalhes'">
              <ul
                style="
                  margin: 0.2rem 0;
                  font-size: 0.9rem;
                  color: #36414a;
                  padding-left: 1.2rem;
                "
              >
                <ng-container *ngFor="let key of getKeys(categoria.values)">
                  <li
                    *ngIf="temVariasOpcoes(categoria.values[key])"
                    style="margin-bottom: 0.3rem"
                  >
                    <strong>{{ key }}:</strong>
                    <ul style="margin: 0.2rem 0; padding-left: 1.2rem">
                      <li *ngFor="let opt of getOpcoes(categoria.values[key])">{{ opt }}</li>
                    </ul>
                  </li>
                  <li *ngIf="!temVariasOpcoes(categoria.values[key])">
                    {{ key }}: {{ categoria.values[key] }}
                  </li>
                </ng-container>
              </ul>
            </ng-container>
            <ng-container *ngIf="categoria.name !== 'Cronograma' && categoria.name !== 'Mais Detalhes'">
              <p style="margin: 0.2rem 0; font-size: 0.9rem; color: #36414a">
                <ng-container *ngFor="let key of getKeys(categoria.values)">
                  {{ key }}: {{ categoria.values[key] }}
                  <span *ngIf="!isLastKey(key, categoria.values)"> - </span>
                </ng-container>
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL FOOTER -->
<div class="modal-footer no-print">
  <button
    class="btn"
    style="background: #da6c00; color: #fff"
    (click)="imprimir()"
  >
    IMPRIMIR
  </button>
</div>
